export const gpSystemTemplatesKeys = ['scanInstructions', 'scanReminders']
